(() => {
  if (window.lgForms1183668Installed) return;
  window.lgForms1183668Installed = true;

const ids = [
  'lg-formulario-1183668',
  'lg-formulario-1210095'
];

const selector = ids
  .map(id => 'a[href="#' + id + '"]')
  .join(',');
  let active = null;
  let opener = null;
  let releaseScroll = null;
  let backdropDown = false;

function decorate() {
  document.querySelectorAll(selector).forEach(link => {
    const id = link.getAttribute('href').slice(1);

    if (!document.getElementById(id)) return;

    link.setAttribute('aria-haspopup', 'dialog');
    link.setAttribute('aria-controls', id);
  });
}
  function viewport() {
    if (!active) return;

    const view = window.visualViewport;

    active.style.setProperty(
      '--lg-modal-height',
      (view ? view.height : innerHeight) + 'px'
    );

    active.style.setProperty(
      '--lg-modal-top',
      (view ? view.offsetTop : 0) + 'px'
    );
  }

  function lockScroll() {
    const x = scrollX;
    const y = scrollY;
    const saved = [];

    function set(element, property, value) {
      const style = element.style;

      saved.push([
        style,
        property,
        style.getPropertyValue(property),
        style.getPropertyPriority(property),
        value
      ]);

      style.setProperty(property, value, 'important');
    }

    set(document.documentElement, 'overflow', 'hidden');
    set(document.body, 'position', 'fixed');
    set(document.body, 'top', -y + 'px');
    set(document.body, 'left', -x + 'px');
    set(document.body, 'width', '100%');
    set(document.body, 'overflow', 'hidden');

    return () => {
      saved.reverse().forEach(
        ([style, property, value, priority, applied]) => {
          if (
            style.getPropertyValue(property) !== applied ||
            style.getPropertyPriority(property) !== 'important'
          ) return;

          if (value) {
            style.setProperty(property, value, priority);
          } else {
            style.removeProperty(property);
          }
        }
      );

      const root = document.documentElement.style;
      const value = root.getPropertyValue('scroll-behavior');
      const priority = root.getPropertyPriority('scroll-behavior');

      root.setProperty('scroll-behavior', 'auto', 'important');
      window.scrollTo(x, y);

      if (value) {
        root.setProperty('scroll-behavior', value, priority);
      } else {
        root.removeProperty('scroll-behavior');
      }
    };
  }

  function close(returnFocus = true) {
    if (!active) return;

    const dialog = active;
    const previous = opener;

    active = null;
    opener = null;
    backdropDown = false;

    if (dialog.open) dialog.close();
    if (releaseScroll) releaseScroll();
    releaseScroll = null;

    dialog.style.removeProperty('--lg-modal-height');
    dialog.style.removeProperty('--lg-modal-top');

    if (returnFocus) {
      const target = previous && previous.isConnected
        ? previous
        : document.querySelector(selector) ||
          document.getElementById('MainContent');

      if (target) target.focus({ preventScroll: true });
    }
  }

  function outside(event) {
    if (!active || event.target !== active) return false;

    const rect = active.getBoundingClientRect();

    return (
      event.clientX < rect.left ||
      event.clientX > rect.right ||
      event.clientY < rect.top ||
      event.clientY > rect.bottom
    );
  }

  document.addEventListener('pointerdown', event => {
    backdropDown = outside(event);
  }, true);

  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;

    const link = event.target.closest(selector);

    if (link) {
      if (
        event.button !== 0 ||
        event.metaKey ||
        event.ctrlKey ||
        event.shiftKey ||
        event.altKey
      ) return;

const id = link.getAttribute('href').slice(1);
const dialog = document.getElementById(id);
if (!dialog) return;
      event.preventDefault();
      event.stopPropagation();

      if (active) return;

      if (typeof dialog.showModal !== 'function') {
        window.alert(
          'Este formulario necesita un navegador actualizado.'
        );
        return;
      }

      active = dialog;
      opener = link;
      releaseScroll = lockScroll();
      viewport();

      try {
        dialog.showModal();

        dialog.querySelector('[data-lg-form-close]')
          .focus({ preventScroll: true });
      } catch (error) {
        close();
        console.error('No se pudo abrir el formulario', error);
      }

      return;
    }

    if (!active) return;

    const button = event.target.closest('[data-lg-form-close]');

    if (button && active.contains(button)) {
      event.preventDefault();
      close();
    } else if (backdropDown && outside(event)) {
      close();
    }

    backdropDown = false;
  }, true);

  document.addEventListener('cancel', event => {
    if (event.target !== active) return;

    event.preventDefault();
    close();
  }, true);

  document.addEventListener('close', event => {
    if (event.target === active && !active.open) close();
  }, true);

  document.addEventListener('shopify:section:unload', event => {
    if (active && event.target.contains(active)) close(false);
  });

  document.addEventListener('shopify:section:load', decorate);

  window.addEventListener('pagehide', () => close(false));
  window.addEventListener('resize', viewport);

  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', viewport);
    window.visualViewport.addEventListener('scroll', viewport);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', decorate, {
      once: true
    });
  } else {
    decorate();
  }
  
  // LOLA GLAMOUR - Evitar etiquetas superpuestas en Forms
  function corregirEtiquetasForms(event) {
    const ruta = event.composedPath();
    const campo = ruta[0];

    // Solo actuar dentro de nuestros dos formularios
    const dialogo = ruta.find(
      el => el instanceof HTMLDialogElement &&
      ids.includes(el.id)
    );

    if (!dialogo) return;

    if (!(campo instanceof HTMLInputElement ||
          campo instanceof HTMLTextAreaElement)) return;

    // No modificar archivos, casillas ni botones
    if (['file', 'checkbox', 'radio', 'submit'].includes(campo.type)) {
      return;
    }

    Array.from(campo.labels || []).forEach(etiqueta => {
      // No ocultar etiquetas que contengan el propio campo
      if (etiqueta.contains(campo)) return;

      if (campo.value.trim() !== '') {
        etiqueta.style.setProperty('opacity', '0', 'important');
      } else {
        etiqueta.style.removeProperty('opacity');
      }
    });
  }

  document.addEventListener('input', corregirEtiquetasForms, true);
  document.addEventListener('change', corregirEtiquetasForms, true);
  document.addEventListener('focusin', corregirEtiquetasForms, true);

})();